(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }

  return "";
}

jQuery(window).load(function () {
  var theme_color = localStorage.getItem("theme");
  if (theme_color != null) jQuery('body').addClass(theme_color);
  jQuery('.mobile-navbar img').on('click', function () {
    if (webkit) {
      webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify({
        'my_message': 'back'
      }));
    }
  });
  jQuery('#delivery_time').attr('readonly', true);

  if (getCookie("showNavbar") == 'true') {
    jQuery('body').addClass('show-navbar');
    jQuery('.woocommerce-notice--success').css('margin', '20px auto 15px');
  }
});
jQuery(document).ready(function () {
  jQuery('.close-button svg').on('click', function () {
    if (window.parent.webkit) {
      window.parent.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify({
        'my_message': 'back'
      }));
    }
  });
});

},{}]},{},[1]);
